import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled React Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#090d16',
          color: '#f8fafc',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          fontFamily: 'Inter, system-ui, sans-serif'
        }}>
          <div style={{
            background: '#1e293b',
            border: '1px solid #ef4444',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '440px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
          }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>⚠️</div>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '800', color: '#f87171', margin: '0 0 8px 0' }}>
              Une erreur est survenue
            </h2>
            <p style={{ fontSize: '0.8rem', color: '#94a3b8', margin: '0 0 16px 0', wordBreak: 'break-word', background: '#0f172a', padding: '10px', borderRadius: '8px', border: '1px solid #334155' }}>
              {this.state.error?.message || 'Erreur inattendue au démarrage de l\'application.'}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                  background: '#38bdf8',
                  color: '#0f172a',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 16px',
                  fontWeight: '800',
                  fontSize: '0.82rem',
                  cursor: 'pointer'
                }}
              >
                Recharger l'application
              </button>
              <button
                type="button"
                onClick={() => {
                  try {
                    localStorage.removeItem('loops_driver_auth_token');
                    localStorage.removeItem('loops_driver_id');
                  } catch (e) {}
                  window.location.reload();
                }}
                style={{
                  background: 'transparent',
                  color: '#94a3b8',
                  border: '1px solid #475569',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontWeight: '600',
                  fontSize: '0.75rem',
                  cursor: 'pointer'
                }}
              >
                Réinitialiser la session chauffeur
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
